import { useLayoutEffect } from 'react';
import { Routes, Route, Navigate, useNavigate } from 'react-router-dom';
import { Unauthorized } from 'pages/Unauthorized';
import SessionExpired from 'pages/SessionExpired';
import { SignOut } from 'pages/SignOut';
import { Index as Portal } from 'pages/Index';
import { Routes as PortalRoutes } from 'routes/Routes';
import { setRouterNavigate } from 'utils/navigation';
import { PublicRoute } from 'components/PublicRoute';

function App() {
  const navigate = useNavigate();

  useLayoutEffect(() => {
    setRouterNavigate(navigate);

    return () => setRouterNavigate(null);
  }, [navigate]);

  return (
    <Routes>
      <Route
        path="unauthorized"
        element={<PublicRoute element={<Unauthorized />} />}
      />
      <Route
        path="session-expired"
        element={<PublicRoute element={<SessionExpired />} />}
      />
      <Route path="sign-out" element={<SignOut />} />

      {/* TODO: separate route for those requests coming from scheduler containing tokens like these /portal/:uidb/:token?resource_type=type&resource_id=id */}

      {/* Patient Portal: public index page */}
      <Route path="portal" element={<Portal />} />

      {/* Patient Portal: all authenticated routes + resource show pages */}
      <Route path="portal/*" element={<PortalRoutes />} />

      <Route path="*" element={<Navigate to="portal/dashboard" replace />} />
    </Routes>
  );
}

export default App;
